import { render, staticRenderFns } from "./board-changelog-item-loader.vue?vue&type=template&id=116e2152"
import script from "./board-changelog-item-loader.vue?vue&type=script&lang=js"
export * from "./board-changelog-item-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports